var _style, _circle, _path, _circle2, _path2, _circle3, _path3, _line, _line2, _line3, _line4, _line5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "82 269 476 149",
    style: {
      enableBackground: "new 0 0 200 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#fff;}\r\n\t.st1{fill:#fff;}\r\n\t.st2{fill:none;stroke:url(#SVGID_1_);stroke-width:10;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:url(#SVGID_2_);stroke-width:10;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st4{fill:none;stroke:url(#SVGID_3_);stroke-width:10;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st5{fill:none;stroke:url(#SVGID_4_);stroke-width:10;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st6{fill:none;stroke:url(#SVGID_5_);stroke-width:10;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st7{fill:none;stroke:url(#SVGID_6_);stroke-width:10;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st8{fill:none;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 313,
    cy: 316.2,
    r: 40
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M245,413c7.5-30.7,34.3-52.7,65-54c32.8-1.4,62.9,21.2,71,54"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 404.5,
    cy: 316.2,
    r: 24.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 366.8,
    y1: 376.8074,
    x2: 455.3,
    y2: 376.8074
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M371.8,369.7c18-12.8,40.7-14.3,57.5-4c14.9,9.2,19.8,24.5,21,29"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 220.2,
    cy: 316.2,
    r: 24.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.0676,
    y1: 401.9664,
    x2: 240.5262,
    y2: 401.9664,
    gradientTransform: "matrix(0.8307 -0.5567 0.5567 0.8307 -180.8853 157.6432)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M169.4,398.2c7.9-20.6,25.9-34.6,45.5-35.3c17.5-0.7,30.1,9.4,33.6,12.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 451,
    y1: 308.6,
    x2: 534,
    y2: 308.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.009497275,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    }
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 456,
    y1: 276.2,
    x2: 529,
    y2: 341
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 464.8343,
    y1: 370.9565,
    x2: 531.8342,
    y2: 370.9565,
    gradientTransform: "matrix(1.0952 -9.552184e-02 -9.552184e-02 1.0958 -17.7968 17.8538)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.009497275,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    }
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 458.6,
    y1: 410.8,
    x2: 526.4,
    y2: 342.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 83.3,
    y1: 380.5,
    x2: 166.3,
    y2: 380.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.009497275,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    }
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 88.3,
    y1: 348.1,
    x2: 161.3,
    y2: 412.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.84,
    y1: 243.3889,
    x2: 94.8196,
    y2: 243.3889,
    gradientTransform: "matrix(-9.212892e-02 0.9957 -0.9957 -9.212892e-02 372.0601 277.8731)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.009497275,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    }
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 160.4,
    y1: 275.2,
    x2: 89.2,
    y2: 342
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 245,
    y1: 413,
    x2: 381,
    y2: 413
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/Logo1.461c4ffecec45ae49afbd79e2afd3dc2.svg";
export { ForwardRef as ReactComponent };